import { helperServices } from "../../shared/helper";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api/v1/subscriptions";

function buildHeaders() {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: helperServices.getAuthorization() || "",
  };
}

export function getSubscriptionPlans() {
  return apiFetch(`${basePath}/plans`, {
    method: "GET",
    headers: buildHeaders(),
  });
}

export function getActiveSubscriptionStatus(patientId) {
  return apiFetch(
    `${basePath}/active-status?patientId=${encodeURIComponent(patientId)}`,
    {
      method: "GET",
      headers: buildHeaders(),
    },
  );
}

export function activateSubscription(payload) {
  return apiFetch(`${basePath}/activate`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  });
}

export function getSubscriptionBalances(patientId) {
  return apiFetch(
    `${basePath}/balances?patientId=${encodeURIComponent(patientId)}`,
    {
      method: "GET",
      headers: buildHeaders(),
    },
  );
}

export function consumeSubscription(payload) {
  return apiFetch(`${basePath}/consume`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  });
}

export function getSubscriptionUsageHistory(patientId, visitId, page = 0) {
  return apiFetch(
    `${basePath}/usage-history?patientId=${encodeURIComponent(patientId)}&visitId=${encodeURIComponent(visitId)}&page=${encodeURIComponent(page)}`,
    {
      method: "GET",
      headers: buildHeaders(),
    },
    { showLoader: false },
  );
}

export function getPatientSubscriptionUsageHistory(patientId) {
  return apiFetch(
    `${basePath}/patient-usage-history?patientId=${encodeURIComponent(patientId)}`,
    {
      method: "GET",
      headers: buildHeaders(),
    },
    { showLoader: false },
  );
}

const subscriptionService = {
  getSubscriptionPlans,
  getActiveSubscriptionStatus,
  activateSubscription,
  getSubscriptionBalances,
  consumeSubscription,
  getSubscriptionUsageHistory,
  getPatientSubscriptionUsageHistory,
};

export default subscriptionService;
